import React from 'react';

import { Typography, Container, Paper } from '@material-ui/core';
import PropTypes from 'prop-types';

import Jumbotron from '../Jumbotron';

import useStyles from './DialogViewWrapper.styles';

const DialogViewWrapper = ({ children, title, contentSize, noCardPadding, maxWidth, onBack }) => {
  const styles = useStyles({ contentSize, noCardPadding });

  return (
    <Container className={styles.wrapper} maxWidth={maxWidth}>
      <Jumbotron background='white' onBack={onBack} showBackButton>
        <Typography align='center' component='h1' variant='h1'>
          {title}
        </Typography>
      </Jumbotron>
      <Paper className={styles.content}>{children}</Paper>
    </Container>
  );
};

DialogViewWrapper.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  contentSize: PropTypes.string,
  noCardPadding: PropTypes.bool,
  maxWidth: PropTypes.string,
  onBack: PropTypes.func,
};

DialogViewWrapper.defaultProps = {
  contentSize: 'sm',
  maxWidth: 'md',
  noCardPadding: false,
  onBack: undefined,
};

export default DialogViewWrapper;
